import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/bot_express_logo.png'


const _hoisted_1 = { class: "min-h-screen bg-zinc-900 flex items-center justify-center p-1 sm:p-4 font-nunito" }
const _hoisted_2 = { class: "w-full max-w-lg" }
const _hoisted_3 = { class: "bg-white/5 rounded-xl overflow-hidden" }
const _hoisted_4 = { class: "p-6 sm:p-8" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = ["type"]
const _hoisted_8 = {
  key: 0,
  class: "text-red-500 text-sm mt-1"
}
const _hoisted_9 = { class: "space-y-2" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = ["type"]
const _hoisted_12 = {
  key: 0,
  class: "text-red-500 text-sm mt-1"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "mt-8 text-center" }
const _hoisted_15 = { class: "text-[#888888] text-sm" }

import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { toast, Toaster } from '@/components/ui/toast'
import { useAuth } from '@/composables/useAuth'
import { Loader2, Eye, EyeOff, KeyRound } from 'lucide-vue-next'

// Estado do formulário

export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  props: {
    token: {}
  },
  setup(__props: any) {

const props = __props
const router = useRouter()
const { resetPassword } = useAuth()

const password = ref('')
const confirmPassword = ref('')
const showPassword = ref(false)
const showConfirmPassword = ref(false)
const isLoading = ref(false)
const errors = ref({
  password: '',
  confirmPassword: ''
})

const validatePassword = (password: string) => {
  return password.length >= 8
}

// Computed property para verificar se o formulário é válido
const isValid = computed(() => {
  return (
    password.value &&
    confirmPassword.value &&
    password.value === confirmPassword.value &&
    validatePassword(password.value) &&
    Object.values(errors.value).every(error => !error)
  )
})

watch(password, (newValue) => {
  if (!newValue) {
    errors.value.password = 'Senha é obrigatória'
  } else if (!validatePassword(newValue)) {
    errors.value.password = 'A senha deve ter pelo menos 8 caracteres'
  } else {
    errors.value.password = ''
  }
  
  if (confirmPassword.value && newValue !== confirmPassword.value) {
    errors.value.confirmPassword = 'As senhas não coincidem'
  } else {
    errors.value.confirmPassword = ''
  }
})

watch(confirmPassword, (newValue) => {
  if (!newValue) {
    errors.value.confirmPassword = 'Confirmação de senha é obrigatória'
  } else if (newValue !== password.value) {
    errors.value.confirmPassword = 'As senhas não coincidem'
  } else {
    errors.value.confirmPassword = ''
  }
})

// Função de submit
const handleSubmit = async () => {
  if (!isValid.value) return

  isLoading.value = true
  try {
    await resetPassword({
      token: props.token,
      password: password.value
    })

    toast({
      title: 'Senha redefinida com sucesso!',
      description: 'Você já pode fazer login com sua nova senha',
      class: 'bg-green-500 text-white',
      duration: 3000
    })

    // Limpar formulário
    password.value = ''
    confirmPassword.value = ''

    // Redirecionar para login após 2 segundos
    setTimeout(() => {
      router.push('/login')
    }, 2000)
  } catch (error) {
    toast({
      title: 'Erro ao redefinir senha',
      description: 'Tente novamente mais tarde ou solicite uma redefinição de senha novamente',
      class: 'bg-red-500 text-white',
      duration: 3000
    })
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex items-center justify-center mb-8" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo",
            class: "h-auto w-[180px] sm:w-[280px]"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mb-8" }, [
              _createElementVNode("h2", { class: "text-white text-2xl font-bold mb-2" }, "Redefinir Senha"),
              _createElementVNode("p", { class: "text-[#888888]" }, "Digite uma nova senha para a sua conta")
            ], -1)),
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleSubmit, ["prevent"]),
              class: "space-y-5"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("label", {
                  for: "password",
                  class: "block text-sm font-medium text-[#AAAAAA]"
                }, "Nova Senha", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    id: "password",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                    type: showPassword.value ? 'text' : 'password',
                    required: "",
                    class: _normalizeClass(["w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-[#555555] focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200", { 'ring-2 ring-red-500': errors.value.password }]),
                    placeholder: "••••••••"
                  }, null, 10, _hoisted_7), [
                    [_vModelDynamic, password.value]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showPassword.value = !showPassword.value)),
                    class: "absolute inset-y-0 right-0 flex items-center pr-3 text-[#555555] hover:text-[#AAAAAA] transition-colors"
                  }, [
                    (!showPassword.value)
                      ? (_openBlock(), _createBlock(_unref(Eye), {
                          key: 0,
                          class: "w-5 h-5"
                        }))
                      : (_openBlock(), _createBlock(_unref(EyeOff), {
                          key: 1,
                          class: "w-5 h-5"
                        }))
                  ])
                ]),
                (errors.value.password)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errors.value.password), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[5] || (_cache[5] = _createElementVNode("label", {
                  for: "confirmPassword",
                  class: "block text-sm font-medium text-[#AAAAAA]"
                }, "Confirmar Senha", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    id: "confirmPassword",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmPassword).value = $event)),
                    type: showConfirmPassword.value ? 'text' : 'password',
                    required: "",
                    class: _normalizeClass(["w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-[#555555] focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200", { 'ring-2 ring-red-500': errors.value.confirmPassword }]),
                    placeholder: "••••••••"
                  }, null, 10, _hoisted_11), [
                    [_vModelDynamic, confirmPassword.value]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value)),
                    class: "absolute inset-y-0 right-0 flex items-center pr-3 text-[#555555] hover:text-[#AAAAAA] transition-colors"
                  }, [
                    (!showConfirmPassword.value)
                      ? (_openBlock(), _createBlock(_unref(Eye), {
                          key: 0,
                          class: "w-5 h-5"
                        }))
                      : (_openBlock(), _createBlock(_unref(EyeOff), {
                          key: 1,
                          class: "w-5 h-5"
                        }))
                  ])
                ]),
                (errors.value.confirmPassword)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errors.value.confirmPassword), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["w-full py-3 px-4 bg-[#10B981] hover:bg-[#0EA271] text-white font-medium rounded-md transition-colors duration-200 flex items-center justify-center", {
                'opacity-50 cursor-not-allowed': !isValid.value || isLoading.value
              }]),
                disabled: !isValid.value || isLoading.value
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createBlock(_unref(Loader2), {
                      key: 0,
                      class: "w-4 h-4 animate-spin mr-2"
                    }))
                  : _createCommentVNode("", true),
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Redefinir Senha", -1)),
                _createVNode(_unref(KeyRound), { class: "ml-2 w-4 h-4" })
              ], 10, _hoisted_13)
            ], 32),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, [
                _cache[8] || (_cache[8] = _createTextVNode(" Lembrou sua senha? ")),
                _createVNode(_component_RouterLink, {
                  to: "/login",
                  class: "text-[#10B981] hover:text-[#0EA271] font-medium ml-1 transition-colors"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode(" Voltar ao login ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_unref(Toaster))
  ], 64))
}
}

})